import * as React from 'react'
import styled from 'styled-components'
import { SPACE } from '../../styles/constants'

import { SelectMenu } from './SelectMenu'
import { Button } from '../Button'
import { Icon } from '../Icon'

interface Props {
  name: string
  options: Option<string>[]
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void
  value: string | string[]
  title?: string | JSX.Element
}

interface State {
  isVisible: boolean
  selected?: Option<string>
}

export class Select extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isVisible: false,
      selected: props.options.find((obj: Option<string>) => obj.value === props.value),
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.value !== this.props.value) {
      this.setState({
        selected: this.props.options.find((obj: Option<string>) => obj.value === nextProps.value),
      })
    }
  }

  element?: HTMLDivElement

  handleOpen = () => {
    this.setState({ isVisible: true })
  }

  handleClose = () => {
    this.setState({ isVisible: false })
  }

  /* Todo: any */
  handleChange = (option: any) => {
    this.setState({ selected: option })
    this.props.onChange(option)
    this.handleClose()
  }

  render() {
    const { selected, isVisible } = this.state
    const { title, options } = this.props
    return (
      <Wrapper innerRef={(element) => (this.element = element)}>
        {selected && (
          <SelectButton size="micro" onClick={this.handleOpen} role="button" aria-haspopup="true">
            {selected.label} <Icon size={13} icon="caron" />
          </SelectButton>
        )}
        {isVisible && (
          <SelectMenu
            options={options}
            onClose={this.handleClose}
            onChange={this.handleChange}
            parentElem={this.element}
            title={title}
            selected={selected}
          />
        )}
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  position: relative;
  display: inline-block;
`

const SelectButton = styled(Button)`
  align-items: center;
  display: flex;
  margin: 0;
  &:hover {
    top: 0;
  }

  svg {
    transition: all 150ms ease-in-out;
    ${SPACE.inline.xs};
  }

  &:focus,
  &:active {
    top: 0;
    svg {
      transform: rotate(180deg);
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Select/index.tsx